module.exports = __webpack_public_path__ + "static/media/filter.26db040e.svg";